import { h } from 'preact'
import globals from '../../utils/globals'

type Props = {
  href: string,
  phrase: string
}

const GoogleButton = ({ href, phrase } : Props) => <a
  target='_top'
  href={href}
  class='btn--cta btn--sso qa-sso-google'
  style={{
    display: 'flex',
    fontFamily: 'Roboto',
    alignItems: 'center',
    background: 'white',
    color: '#737373',
    border: '1px solid #dadce0',
    boxShadow: 'none'
  }}>
  <div style={{ flex: 1 }} >
    <img src={`${globals('basePath')}images/g-logo.png`} style={{ height: '18px', float: 'left' }} />
  </div>
  <div>{ phrase }</div>
  <div style={{ flex: 1 }} />
</a>

export default GoogleButton
